var Utils = require('./Utils');

function Column(data){
    var self = this;

    self.column = data.column;
    self.display_name = data.display_name;
    self.selected = ko.observable(data.selected);
}

function Sort(data){
    var self = this;

    self.column = ko.observable(data.column);
    self.direction = ko.observable(data.direction);
}

function Filter(data){
    var self = this;
    self.column = ko.observable(data.column);
    self.operator = ko.observable(data.operator);
    self.value = ko.observable(data.value);
}

function PageFilterWidget(config,data){
    var self = this;
    self.inner = function () {};
    self.fn = function () {};

    self.token = config.token;

    self.inner.utils = config.utils != null ? config.utils: new Utils();
    self.inner.apiClient = self.inner.utils.getApiClient(config);

    self.inner.processing = ko.observable(false);
    self.columns = ko.observableArray([]);
    self.sort = ko.observableArray([]);
    self.filters = ko.observableArray([]);
    self.userViews = ko.observableArray([]);


    self.selected_view_unique_id = ko.observable(config.unique_id);
    self.unique_id = ko.observable(config.unique_id);
    self.display_name = ko.observable(config.display_name);
    self.new_display_name = ko.observable();

    self.inner.url = {
        save_view: config.url.save_view,
        filter: config.url.filter
    }

    self.unique_id.subscribe(function(newValue) {
        if (newValue) {
            self.selected_view_unique_id(newValue);
            if(!self.inner.processing())
                $(document).trigger('reload-view',newValue);
        }
    });

    self.columns_expanded = ko.observable(false);
    self.sort_expanded = ko.observable(false);
    self.filters_expanded = ko.observable(false);

    self.showSaveAsForm = ko.observable(false);

    self.fn.toggleColumns = function(){
        self.columns_expanded(!self.columns_expanded());
    }
    self.fn.toggleSort = function(){
        self.sort_expanded(!self.sort_expanded());
    }
    self.fn.toggleFilters = function(){
        self.filters_expanded(!self.filters_expanded());
    }

    self.fn.toggleSaveName = function(){
        self.showSaveAsForm(!self.showSaveAsForm());
    }

    self.fn.saveView = function(_export){

        self.inner.processing(true);
        var data = {
            _token: self.token,
            uv: self.selected_view_unique_id(),
            display_name: self.display_name(),
            columns: ko.toJS(self.columns()),
            sort: ko.toJS(self.sort()),
            filters: ko.toJS(self.filters())
        };
        self.inner.apiClient.call(self.inner.url.save_view,data,function(response){

            if(response.success){
                self.unique_id(response.data);
                if(_export == true)
                    $(document).trigger('export-view',response.data);
                else
                    $(document).trigger('view-saved',response.data);
            }
            else{
                self.inner.utils.alert(response.message,'error');
                self.inner.processing(false);
            }
        },function(e){
            self.inner.utils.alert('Error occurred while saving view','error');
            self.inner.processing(false);
        },'POST');
    }

    self.fn.export = function(){
        self.fn.saveView(true);
    }

    self.fn.loadColumns = function(columns){
        self.columns([]);
        for(var i in columns){
            self.columns.push(new Column(columns[i]));
        }
    }
    self.fn.loadSort = function(sort){
        self.sort([]);
        for(var i in sort){
            self.sort.push(new Sort(sort[i]));
        }
    }
    self.fn.loadFilters = function(filters){
        self.filters([]);
        for(var i in filters){
            self.filters.push(new Filter(filters[i]));
        }
    }


    self.fn.addSort = function(){
        self.sort.push(new Sort({ column:'','direction': 'asc'}));
    }
    self.fn.addFilter = function(){
        self.filters.push(new Filter({ column:'','operator': '=','value': ''}));
    }

    self.fn.deleteSort = function(element){
        self.sort.remove(element);
    }
    self.fn.deleteFilter = function(element){
        self.filters.remove(element);
    }

    self.fn.loadUserViews = function(data){
        self.userViews([]);
        for(var i in data)
            self.userViews.push(data[i]);
    }

    self.fn.loadColumns(config.columns);
    self.fn.loadSort(config.sort);
    self.fn.loadFilters(config.filters);
    self.fn.loadUserViews(config.user_views);

    self.fn.totalColumns = ko.computed(function(){
        var filteredArray = ko.utils.arrayFilter(self.columns(), function(item) {
            return ko.unwrap(item.selected);
        });
        var total = filteredArray.length;
        return "("+total+")";
    });

    self.fn.totalSort = ko.computed(function(){
       var total = self.sort().length;
       return "("+total+")";
    });

    self.fn.totalFilters = ko.computed(function(){
        var total = self.filters().length;
        return "("+total+")";
    });

    self.fn.saveCopyOfView = function(){
        self.inner.processing(true);
        self.selected_view_unique_id(null);
        self.display_name(self.new_display_name());
        self.fn.saveView();
    }

    self.fn.selectAll = ko.pureComputed({
        // READ: Checks the "All" box if every single column is selected
        read: function () {
            var cols = self.columns();
            if (cols.length === 0) return false;
            return cols.every(function (col) {
                return col.selected();
            });
        },
        // WRITE: When "All" is clicked, set all columns to that value
        write: function (value) {
            ko.utils.arrayForEach(self.columns(), function (col) {
                col.selected(value);
            });
        }
    });

    self.inner.draggedIndex = ko.observable(null);

    self.fn.dragStart = function(index, data, event) {
        self.inner.draggedIndex(index);

        // Now 'event' is properly mapped to the native browser event object
        if (event && event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', index);
        }
    };

    self.fn.dragDrop = function(targetIndex, event) {
        event.preventDefault();

        var sourceIndex = self.inner.draggedIndex();
        if (sourceIndex === null || sourceIndex === targetIndex) {
            return;
        }

        // Get raw array underlying the observableArray
        var underlyingArray = self.columns();

        // Remove the dragged element from its old position
        var movedItem = underlyingArray.splice(sourceIndex, 1)[0];

        // Insert it into its new position
        underlyingArray.splice(targetIndex, 0, movedItem);

        // Notify Knockout that the array values changed so the UI updates
        self.columns.valueHasMutated();

        // Reset drag tracking state
        self.inner.draggedIndex(null);
    };
}

module.exports = PageFilterWidget;
